import {
  AutomationActionLessonlyAssignToContentDenormalized,
  IAutomationActionTemplateLessonlyAssignToContent
} from '@dadohr/shared/domainTypes/experience';
import { useUnsafeTranslation } from '../../../../../../../i18next';
import { joinWithCommaAndAnd } from '../../../../../../../services/enumerate';
import { LightMdToJsx } from '../../../../../../../services/formatter';
import { toWeekOrDayDuration } from '../../../../../../../services/time';
import { MinimalTaskBuilderContext } from '../../../TaskBuilder/types';
import { actionActorToString } from '../../shared';
import { ActionDefinition } from '../../types';
import {
  ActionSummaryBody,
  ActionSummaryContainer,
  ActionSummaryHeading
} from '../shared';

export const ActionSummaryLessonlyAssignToContent = ({
  a,
  expTpl,
  def
}: {
  a:
    | IAutomationActionTemplateLessonlyAssignToContent
    | AutomationActionLessonlyAssignToContentDenormalized;
  expTpl: MinimalTaskBuilderContext;
  def: ActionDefinition;
}) => {
  const { t } = useUnsafeTranslation();
  return (
    <ActionSummaryContainer>
      <ActionSummaryHeading def={def} />
      <ActionSummaryBody>
        <LightMdToJsx>
          {t(
            'Assign **{{ participants }}** to the {{ contentType }} **{{ content }}**.',
            {
              participants:
                joinWithCommaAndAnd(
                  a.pplToAdd.map((o) =>
                    actionActorToString(o, expTpl.supportingActors, t)
                  ),
                  t
                ) || 'someone',
              content: a.content.name || 'TBD',
              contentType:
                a.content.type === 'path'
                  ? t('Path')
                  : a.content.type === 'certification'
                  ? t('Certification')
                  : t('Lesson')
            }
          )}
        </LightMdToJsx>
        {a.duration !== null && (
          <>
            {' '}
            <LightMdToJsx>
              {t('Give them **{{ time }}** to complete the assignment.', {
                time: toWeekOrDayDuration(a.duration, t)
              })}
            </LightMdToJsx>
          </>
        )}
      </ActionSummaryBody>
    </ActionSummaryContainer>
  );
};
